__turbopack_context__.v({
  "carouselCont": "index-module-scss-module__sqUtfG__carouselCont",
  "img": "index-module-scss-module__sqUtfG__img",
  "swiper": "index-module-scss-module__sqUtfG__swiper",
});
